import { UpperCasePipe } from '@angular/common';
import { ChangeDetectionStrategy, Component, inject, signal } from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatIconModule } from '@angular/material/icon';
import { WhiteLabelService } from '@flexyoo/common';
import { employeeSelectedBenefitsSelectors } from '@flexyoo/employee/store';
import { FlexyooNumberPipe } from '@flexyoo/shared/pipes';
import { Store } from '@ngrx/store';
import { TranslateModule } from '@ngx-translate/core';
import { EmployeeBasketFundingsListComponent } from '../employee-basket-fundings-list/employee-basket-fundings-list.component';
import { EmployeeBasketProgressBarComponent } from '../employee-basket-progress-bar/employee-basket-progress-bar.component';

@Component({
  selector: 'flexyoo-employee-pb-basket-info',
  templateUrl: './employee-pb-basket-info.component.html',
  styleUrl: './employee-pb-basket-info.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    TranslateModule,
    MatIconModule,
    MatExpansionModule,
    FlexyooNumberPipe,
    EmployeeBasketProgressBarComponent,
    EmployeeBasketFundingsListComponent,
    UpperCasePipe,
  ],
})
export class EmployeePbBasketInfoComponent {
  private readonly store = inject(Store);

  protected readonly wls = inject(WhiteLabelService);
  protected readonly fundingsExpanded = signal(false);

  protected readonly pbBasket = toSignal(
    this.store.select(employeeSelectedBenefitsSelectors.selectPBBasket)
  );
  protected readonly stats = toSignal(
    this.store.select(employeeSelectedBenefitsSelectors.selectStats)
  );
}
